import React, { useEffect, useState } from "react";
import "./dashboard.css";
import crownActive from "../../assets/icons/sidebar/crownActive.svg";
import manageOrderActive from "../../assets/icons/sidebar/manageOrderActive.svg";
import distributionActive from "../../assets/icons/sidebar/truck-sideActive.svg";
import customerActive from "../../assets/icons/sidebar/customer.svg";
import { socket, url } from "../../redux/config";
import { useDispatch } from "react-redux";
import { dashboardView, graphCard } from "../../redux/actions/dashboardAction";
import DashboardGraph from "../dashboard/DashboardGraph";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import AnalyticalReportModal from "../../components/modals/dashboard/downloadAnalyticalModal";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardCounter, setDashboardCounters] = useState(null);
  const [analyticalModalShow, setAnalyticalModalShow] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(null);
  const [showMonthSelect, setShowMonthSelect] = useState("Annually");
  const [graphData, setGraphData] = useState(null);
  const [urlParams, setUrlParams] = useState("completed-orders");
  const [label, setLabel] = useState("Completed Orders");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(dashboardView(onSuccess, onError));
  }, []);

  useEffect(() => {
    socket.on("manufacturer_dashboard", (counters) => {
      console.log("Socket Dataaaaaaaaaaa", counters);
      setDashboardCounters({
        products: counters?.products,
        distributors: counters?.distributors,
        orders: counters?.totalOrders,
        doctorSubscribedVendors: counters?.doctorSubscribedVendors,
        pharmacySubscribedVendors: counters?.pharmacySubscribedVendors,
        completedOrders: counters?.completedOrders,
      });
    });
    return () => {
      socket.off("manufacturer_dashboard");
    };
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    const counters = data.data.data;
    console.log(counters);
    setDashboardData(data.data.data);
    setDashboardCounters({
      products: counters?.products,
      distributors: counters?.distributors,
      orders: counters?.orders,
      doctorSubscribedVendors: counters?.doctorSubscribedVendors,
      pharmacySubscribedVendors: counters?.pharmacySubscribedVendors,
      completedOrders: counters?.completedOrders,
    });
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  useEffect(() => {
    if (month !== new Date().getMonth() + 1 || month !== null) {
      dispatch(
        graphCard({ year, month, urlParams }, onGraphSuccess, onGraphError)
      );
    } else {
      dispatch(graphCard({ year, urlParams }, onGraphSuccess, onGraphError));
    }
  }, [year, month, urlParams]);

  useEffect(() => {
    setYear(new Date().getFullYear());
    setMonth(null);
    setShowMonthSelect("Annually");
  }, [urlParams]);

  const onGraphSuccess = (data) => {
    console.log(data?.data?.data);
    setGraphData(data?.data?.data);
  };

  const onGraphError = (err) => {
    console.log(err);
  };

  const cardDetails = [
    {
      icon: crownActive,
      label: "Products",
      count: dashboardCounter?.products,
      id: "products",
    },
    {
      icon: distributionActive,
      label: "Linked Distributors",
      count: dashboardCounter?.distributors,
      id: "linked-distributor",
    },
    {
      icon: manageOrderActive,
      label: "Total Orders",
      count: dashboardCounter?.orders,
      id: "total-orders",
    },
    {
      icon: customerActive,
      label: "Pharmacies",
      count: dashboardCounter?.pharmacySubscribedVendors,
      id: "pharmacies",
    },
    {
      icon: customerActive,
      label: "Doctors",
      count: dashboardCounter?.doctorSubscribedVendors,
      id: "doctors",
    },
    {
      icon: manageOrderActive,
      label: "Completed Orders",
      count: dashboardCounter?.completedOrders,
      id: "completed-orders",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/dashboard",
      breadcrumb: " / dashboard",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="d-flex justify-content-between align-items-center mx-4">
              <div>
                <h1 className="header-route-page fw_400 fs_16 "></h1>
              </div>
              <AdminButton
              className="my-2"
                width="275px"
                background="#7065e4"
                color="white"
                onClick={() => setAnalyticalModalShow(true)}
              >
                <span className="m-2">Download Detailed Analytical Report</span>
              </AdminButton>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  <div className="container-main-div" style={{height:"90vh"}}>
                    <div className="row gap-lg-4 mx-2 mx-lg-4 my-2 d-flex justify-content-center justify-content-xl-start">
                      {cardDetails.map((item, index) => (
                        <motion.div
                          viewport={{ once: true }}
                          initial={{ opacity: 0 }}
                          animate="visible"
                          whileInView={{
                            opacity: 1,
                            transition: { delay: index * 0.1 },
                          }}
                          className={`card-container col-sm-12 col-xxl-3 col-xl-6 mx-1 cursor_pointer hoverpop ${
                            urlParams == item.id && `activepop`
                          }`}
                          key={index}
                          style={{ maxWidth: "240px" }}
                          onClick={() => {
                            setUrlParams(item.id);
                            setLabel(item.label);
                          }}
                        >
                          <label className="mt-1 pt-1 d-flex align-align-items-center">
                            <img src={item.icon} width={22} height={22} />
                            <span className="fs_14 ms-1  Medium_Purple fw_400 text-uppercase ">
                              {item.label}
                            </span>
                          </label>
                          <p className=" mx-3 ms-4 ps-3 fw_700 fs_20">
                            {item.count}
                          </p>
                        </motion.div>
                      ))}
                    </div>
                    <div className="mt-2">
                      <DashboardGraph
                        year={year}
                        month={month}
                        setYear={setYear}
                        setMonth={setMonth}
                        setShowMonthSelect={setShowMonthSelect}
                        showMonthSelect={showMonthSelect}
                        graphData={graphData}
                        label={label}
                        urlParams={urlParams}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <AnalyticalReportModal
          show={analyticalModalShow}
          handleClose={() => setAnalyticalModalShow(false)}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default Dashboard;
